<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect
        :is-picked-facility="true"
      ></BaseFacilitySelect>
    </div>
    <div>
      <div class="card">
        <div class="card-header">
          <strong>User management: Edit user privileges</strong>
        </div>
        <div class="card-body">
          <div>
            <b-row>
              <b-col sm="1">
                <label for="lastName"><strong>Current Role:</strong></label><br/>
              </b-col>
              <b-col md="5">
                {{ currentTitle }}
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="1">
                <label for="roles"><strong>New role:</strong></label><br/>
              </b-col>
              <b-col md="5" v-if="(hasRole('mdh-admin') || hasRole('mnit-admin'))">
                <b-form-select
                    id="roleOptions"
                    setId="roleOptions"
                    v-model="newRole"
                    :options="roleOptions"
                    slug="roleOptions"
                />
              </b-col>
            </b-row>
            <b-row cols="6">
              <b-col class="mt-auto">
                <b-button class="d-block p-2 bg-mdh text-white" id="searchButton" @click="updateUserRole" role="button">Update user role</b-button>
              </b-col>
              <b-col class="mt-auto">
                <b-button class="d-block p-1 text-white" id="searchButton" @click="backButtonHandler" role="button">Back to search page</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>


<script>

import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import router from "@/router";
import axios from "axios";

export default {
  components: {BaseFacilitySelect},
  data: () => ({
    userEmail: '',
    currentRole: '',
    currentTitle: '',
    newRole: '',
    roleOptions: [
      {value: 'org-user', text: 'Organization User'},
      {value: 'org-admin', text: 'Organization Administrator'},
      {value: 'mdh-admin', text: 'MDH Administrator'},
      {value: 'mnit-admin', text: 'MNIT Administrator'},
    ]
  }),

  mounted() {
    this.returnFullTitle(this.$route.params.roles)
    this.userEmail = this.$route.params.userEmail
  },

  methods: {
    updateUserRole() {
      if (this.currentRole !== null && this.newRole !== null) {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/user/updateUserRole`, this.userEmail, {params: {oldRole: this.currentRole, newRole: this.newRole}})
          .then(response => {
            if (response.status === 200) {
              this.showRootToast('Success','User role has been updated.','success')
              router.push('/userManagementSearch')
            } else {
              this.showRootToast('Error','Error updating user role.','danger')
            }
          })
      }
    },
    returnFullTitle(role) {
      this.roleOptions.forEach(options => {
        if (role === options.value) {
          this.currentTitle = options.text
        }
        this.currentRole = this.$route.params.roles
        return this.currentTitle
      })
    },
    backButtonHandler() {
      router.push('/userManagementSearch')
    },
    hasRole(roles) {
      if (this.$keycloak.authenticated) {
        return this.$keycloak.hasResourceRole(roles);
      } else {
        return false;
      }
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },

  }
}

</script>


<style scoped>

</style>
